/**
 * Checks if a string contains a UUID pattern.
 * UUID format: xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
 * Where M is a version number (1-5) and N is a variant (8, 9, a, or b)
 *
 * @param string The string to check for UUID pattern
 * @returns boolean True if the string contains a UUID pattern, false otherwise
 */
export function containsUuid(string: string): boolean {
    if (!string) return false;

    const uuidRegExp =
        /[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/i;

    return uuidRegExp.test(string);
}
